module.exports = __webpack_public_path__ + "img/3.03.ebfe08f2.jpg";